// imports react
import { useEffect, useState } from "react";

//imports libraries
import * as Yup from "yup";
import { useFormik } from "formik";
import clsx from "clsx";
import { toast } from "sonner";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
//import { parsePhoneNumberFromString } from 'libphonenumber-js';

//imports components
import styles from "../styles/login.module.css";

import { urlAPI_Current } from "../config";
import { LoginBaseBoard } from "../components/LoginBaseBoard";
import { LoginDivEVOK } from "../components/LoginDivEVOK";
import { Moon, Sun } from "lucide-react";
import { SwitchMode } from "../components/SwitchMode";
import { verifyUserPaid } from "../verifyUserPaid";
import Swal from "sweetalert2";

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Formato de email incorreto")
    .min(3, "Minimo de 3 letras")
    .max(50, "Maxido de 50 letras")
    .required("Email é obrigatório"),
  password: Yup.string()
    .min(3, "Minimo de 3 letras")
    .max(50, "Maxido de 50 letras")
    .required("Senha é obrigatória"),
  passwordConfirm: Yup.string()
    .min(3, "Minimo de 3 letras")
    .max(50, "Maxido de 50 letras")
    .required("Confirme a senha é obrigatória"),
  name: Yup.string()
    .min(3, "Minimo de 3 letras")
    .max(50, "Maxido de 50 letras")
    .required("Nome é obrigatório"),
    date: Yup.string()
    .matches(
      /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
      "Data deve estar no formato dd/mm/aaaa"
    )
    .required("Data de nascimento é obrigatória"),
  phone: Yup.string()
    .min(12, "Minimo de 12 digitos totais")
    .required("Celular é obrigatório")
});

const maxYear = new Date().getFullYear() - 18;

const initialValues = {
  email: "",
  password: "",
  name: "",
  date: "",
  phone: "",
  plans: "",
};

// Para obter o pais ou codigo pais
//const phoneNumber = "+351932157097";
//const parsedNumber = parsePhoneNumberFromString(phoneNumber);
//console.log("Codigo pais:", parsedNumber.countryCallingCode);

export function CreateUser() {
  const [isLoading, setIsLoading] = useState(false);
  const navigateTo = useNavigate();
  const [checkBox1, setCheckBox1] = useState(false);
  const [checkBox2, setCheckBox2] = useState(false);

  const [searchParams] = useSearchParams();
  const plan = searchParams.get('plan');
  const token = searchParams.get('token'); // token que vem do link do convite

  const [darkMode, setDarkMode] = useState(() => 
    window.localStorage.getItem('darkMode') === 'true'
  );

  const handleModeChange = (darkMode) => {
    setDarkMode(darkMode);
  };

  async function updateInvitationAccess(token) {
    try{
      const invitationAccess = await axios.post(`${urlAPI_Current}/updateInvitationAccess`, {
        token: token
      }, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
      });
      return invitationAccess.data;
    }catch(err){
        console.log(err)
    }
  }

  async function sendCheckout(plan) {
    if(plan != 1 || plan != '1'){
      Swal.fire({
        title: "Ainda não disponível",
        text: "Em desenvolvimento",
        icon: "info"
      });
    } else {
      try {
        setIsLoading(true);
        const payPlan = plan;
        
        const responsePayment = await axios.post(
          `${urlAPI_Current}/checkoutStripe`,
          {
            payPlan: payPlan
          }, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
            }
         }
        );
        const payment_url = responsePayment.data.linkPayment;
        
        toast.success("Direcionando para uma página segura!");

        window.open(`${payment_url}`, "_blank");
      } catch (err) {
        console.log(err);
      }
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setIsLoading(true);
      console.log(values.plans);
      const formattedDate = convertDateToISO(values.date);

      if (checkBox1) {
        try {

          if (values.password !== values.passwordConfirm) {
            toast.error("As senhas não iguais");
            setIsLoading(false);
            return;
          }

          const responseCreate = await axios.post(`${urlAPI_Current}/createUser`, {
            name: values.name,
            email: values.email,
            password: values.password,
            cellphone: values.phone,
            dateBirth: formattedDate,
            age: calcularIdade(values.date),
            lgpd_box: 1,
          });

          if(responseCreate.data.success == true) {
            const response = await axios.post(`${urlAPI_Current}/login`, {
              email: values.email,
              password: values.password,
            });

            localStorage.setItem("authToken", response.data.authToken);
            localStorage.setItem("idThread", response.data.user.idThread);

            toast.success("Usuario logado com sucesso!");

            // se tiver plano na url. Já leva direto para a pagina de checkout - sem passar pela de plans
            console.log(`Plano url ${plan}`)

            const responsePaid = await verifyUserPaid();
            if(responsePaid.success == false && plan && plan == '1'){
              sendCheckout(plan);
              return;
            }

            if(token) {
              try {
                await updateInvitationAccess(token);
                console.log("Acesso do convite atualizado com sucesso");
              } catch (error) {
                  console.error("Erro ao atualizar acesso do convite:", error);
              }
            }
            
            const verifyIsPaid = await verifyUserPaid();
            const typePaid = verifyIsPaid.type;

            if(typePaid == 'convite'){
              navigateTo("/questionaryAlert");
            } else {
              navigateTo("/plans");
            }
            
          } else if (responseCreate.data.success == false){
            toast.error(`Email já cadastrado!`);
          }
        } catch (error) {
          console.error("Erro ao criar conta", error);
          toast.error(`Erro ao criar conta!`);
        } finally {
          setIsLoading(false);
        }
      } else {
        toast.error("Aceite os termos");
        setIsLoading(false);
      }
    },
  });

  const convertDateToISO = (date) => {
    const [day, month, year] = date.split('/');
    return `${year}-${month}-${day}`;
  };

  function calcularIdade(dataNascimento) {
    const [dia, mes, ano] = dataNascimento.split('/');
    const dataNascimentoFormatada = new Date(`${ano}-${mes}-${dia}`); 

    const dataAtual = new Date();
    let diferenca = dataAtual - dataNascimentoFormatada;

    let idade = Math.floor(diferenca / (1000 * 60 * 60 * 24 * 365.25));

    return idade;
  }

  const formatDate = (input) => {
    const numbers = input.replace(/\D/g, '');

    const day = numbers.slice(0, 2);
    const month = numbers.slice(2, 4);
    const year = numbers.slice(4, 8);

    let formattedDate = day;
    if (month) formattedDate += '/' + month;
    if (year) formattedDate += '/' + year;

    return formattedDate;
  };

  const handleChangeDate = (e) => {
    const formattedValue = formatDate(e.target.value);
    formik.setFieldValue('date', formattedValue);
  };

  function navigateToLogin() {
    if(token){
      navigateTo(`/login?token=${token}`);
    } else if(plan) {
      navigateTo(`/login?plan=${plan}`);
    } else {
      navigateTo(`/login`);
    }
  }

  function navigateToTerms() {
    navigateTo("/");
  }

  function navigateToPlans() {
    navigateTo("/");
  }

  function navigateToContact() {
    navigateTo("/", { target: "_blank" });
  }

  function navigateToTermsOfServices() {
    window.open('https://evoktm.com.br/termos.html', '_blank');
  }

  function navigateToPrivacyPolicies() {
    window.open('https://evoktm.com.br/politica.html', '_blank');
  }

  return (
    <div className={styles.container}>
      <div className="d-flex flex-column flex-root">
        <div className="d-flex flex-column flex-lg-row flex-column-fluid">
          <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
            <div className="d-flex flex-center flex-column flex-lg-row-fluid">
              <div className="w-sm-500px w-300px w-lg-500px p-10">
                <div className="text-center mb-11">
                  <SwitchMode onModeChange={handleModeChange}/>
                  <h1 className="text-gray-900 fw-bolder mb-3" data-bs-theme={darkMode ? ('dark') : ('light')}>Criar Conta</h1>
                </div>

                <div className="separator separator-content my-14">
                  <span className="w-125px text-gray-500 fw-semibold fs-7" data-bs-theme={darkMode ? ('dark') : ('light')}>
                    Crie com email
                  </span>
                </div>

                <form
                  className="form w-100"
                  onSubmit={formik.handleSubmit}
                  noValidate
                  id="kt_login_signin_form"
                  data-bs-theme={darkMode ? ('dark') : ('light')}
                >
                  <div className="fv-row mb-3">
                    <label className="form-label fw-bolder text-gray-900 fs-6 mb-0" data-bs-theme={darkMode ? ('dark') : ('light')}>
                      Nome Completo
                    </label>
                    <input
                      placeholder="Nome"
                      {...formik.getFieldProps("name")}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.name && formik.errors.name,
                        },
                        {
                          "is-valid":
                            formik.touched.name && !formik.errors.name,
                        }
                      )}
                      type="name"
                      name="name"
                      autoComplete="off"
                      data-bs-theme={darkMode ? ('dark') : ('light')}
                    />
                    {formik.touched.name && formik.errors.name && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          <span role="alert">{formik.errors.name}</span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="fv-row mb-3">
                    <label className="form-label fw-bolder text-gray-900 fs-6 mb-0" data-bs-theme={darkMode ? ('dark') : ('light')}>
                      Email
                    </label>
                    <input
                      placeholder="Email"
                      {...formik.getFieldProps("email")}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.email && formik.errors.email,
                        },
                        {
                          "is-valid":
                            formik.touched.email && !formik.errors.email,
                        }
                      )}
                      type="email"
                      name="email"
                      autoComplete="off"
                      data-bs-theme={darkMode ? ('dark') : ('light')}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          <span role="alert">{formik.errors.email}</span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="fv-row mb-3">
                    <label className="form-label fw-bolder text-gray-900 fs-6 mb-0" data-bs-theme={darkMode ? ('dark') : ('light')}>
                      Senha
                    </label>
                    <input
                      placeholder="Senha"
                      type="password"
                      autoComplete="off"
                      {...formik.getFieldProps("password")}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.password && formik.errors.password,
                        },
                        {
                          "is-valid":
                            formik.touched.password && !formik.errors.password,
                        }
                      )}
                      data-bs-theme={darkMode ? ('dark') : ('light')}
                    />
                    {formik.touched.password && formik.errors.password && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          <span role="alert">{formik.errors.password}</span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="fv-row mb-3">
                    <label className="form-label fw-bolder text-gray-900 fs-6 mb-0" data-bs-theme={darkMode ? ('dark') : ('light')}>
                      Confirme a Senha
                    </label>
                    <input
                      placeholder="Confirme a Senha"
                      type="password"
                      autoComplete="off"
                      {...formik.getFieldProps("passwordConfirm")}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.passwordConfirm && formik.errors.passwordConfirm,
                        },
                        {
                          "is-valid":
                            formik.touched.passwordConfirm && !formik.errors.passwordConfirm,
                        }
                      )}
                      data-bs-theme={darkMode ? ('dark') : ('light')}
                    />
                    {formik.touched.passwordConfirm && formik.errors.passwordConfirm && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          <span role="alert">{formik.errors.passwordConfirm}</span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="fv-row mb-3">
                    <label className="form-label fw-bolder text-gray-900 fs-6 mb-0" data-bs-theme={darkMode ? ('dark') : ('light')}>
                      Data Nascimento
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      placeholder="dd/mm/aaaa"
                      maxLength="10"
                      onChange={handleChangeDate}
                      value={formik.values.date}
                      onBlur={formik.handleBlur}
                      name="date" 
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid": formik.touched.date && formik.errors.date,
                        },
                        {
                          "is-valid": formik.touched.date && !formik.errors.date,
                        }
                      )}
                      data-bs-theme={darkMode ? 'dark' : 'light'}
                    />
                    {formik.touched.date && formik.errors.date && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          <span role="alert">{formik.errors.date}</span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="fv-row mb-3">
                    <label className="form-label fw-bolder text-gray-900 fs-6 mb-0" data-bs-theme={darkMode ? ('dark') : ('light')}>
                      Celular
                    </label>
                    <PhoneInput
                      defaultCountry="br"
                      {...formik.getFieldProps("phone")}
                      value={formik.values.phone}
                      onChange={(phone) => formik.setFieldValue("phone", phone)}
                      inputStyle={{
                        width: "100%",
                      }}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.phone && formik.errors.phone,
                        },
                        {
                          "is-valid":
                            formik.touched.phone && !formik.errors.phone,
                        }
                      )}
                      data-bs-theme={darkMode ? ("dark") : ("light")} 
                    />
                    {formik.touched.phone && formik.errors.phone && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          <span role="alert">{formik.errors.phone}</span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className={styles.containerCheckBox}>
                    <div className="fv-row mb-3">
                      <label className={styles.checkbox_label}>
                      <input
                        type="checkbox"
                        checked={checkBox1}
                        className={styles.check_box}
                        onChange={(e) => setCheckBox1(!checkBox1)}
                      />
                      Concordo com os&nbsp;
                      <span
                        className={styles.linkPage}
                        onClick={navigateToPrivacyPolicies}
                      >
                        Termos de Privacidade
                      </span>
                      &nbsp;&&nbsp;
                      <span
                        className={styles.linkPage}
                        onClick={navigateToTermsOfServices}
                      >
                        Termos de Serviço
                      </span>
                      </label>
                    </div>
                    <div className="fv-row mb-3">
                      <label className={styles.checkbox_label}>
                        <input
                          type="checkbox"
                          checked={checkBox2}
                          className={styles.check_box}
                          onChange={(e) => setCheckBox2(!checkBox2)}
                        />
                        Aceito receber promoções e produtos 2Towers High
                        Performance
                      </label>
                    </div>
                  </div>
                  <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
                    <div></div>
                  </div>
                  <div className="d-grid mb-10">
                    <button
                      type="submit"
                      id="kt_sign_in_submit"
                      className="btn btn-primary"
                      disabled={formik.isSubmitting || !formik.isValid}
                    >
                      {!isLoading && (
                        <span className="indicator-label">Criar</span>
                      )}
                      {isLoading && (
                        <span
                          className="indicator-progress"
                          style={{ display: "block" }}
                        >
                          Carregando...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      )}
                    </button>
                  </div>
                </form>

                <div className="text-gray-500 text-center fw-semibold fs-6">
                  Já possui uma conta?{" "}
                  <a onClick={() => navigateToLogin()} className="link-primary cursor-pointer">
                    Entrar
                  </a>
                </div>
              </div>
            </div>

            <LoginBaseBoard />
          </div>

          <LoginDivEVOK />
        </div>
      </div>
    </div>
  );
}
